import { Form } from "antd";
import React, { useEffect, useContext } from 'react';
import { FormDeptTreeSelectSettings } from './FormDeptTreeSelectSettings';

import { Resizer,FormContext } from 'wsc-react-custom-form';
import DeptTreeSelect from "./DeptTreeSelect";

const defaultProps = {
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  fillSpace: 'no',
  padding: ['0', '0', '0', '0'],
  margin: ['0', '0', '0', '0'],
  background: { r: 255, g: 255, b: 255, a: 1 },
  color: { r: 0, g: 0, b: 0, a: 1 },
  shadow: 0,
  radius: 0,
  width: '100%',
  height: 'auto',
};

export const FormDeptTreeSelect = (props) => {
  props = {
    ...defaultProps,
    ...props,
  };
  const {
    flexDirection,
    alignItems,
    justifyContent,
    fillSpace,
    background,
    color,
    padding,
    margin,
    shadow,
    radius,
    label,
    labelSpan,
    labelOffset,
    wrapperSpan,
    wrapperOffset,
    showLabel,
    name,
    rules,
  } = props;

  const { form, formdata } = useContext(FormContext);

  useEffect(() => {
    //表单值发生变化，反应到组件中
    // let fileds = [];
    // fileds[name] = formdata[name];
    // form.setFieldsValue(fileds);
    form.setFieldValue(name, formdata[name]);
  }, [formdata[name]]);

  let noLabel = (showLabel == "false");
  return (<Resizer
    propKey={{ width: 'width', height: 'height' }}
    style={{
      justifyContent,
      flexDirection,
      alignItems,
      background: `rgba(${background.r}, ${background.g}, ${background.b}, ${background.a})})`,
      color: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
      padding: `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`,
      margin: `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`,
      boxShadow:
        shadow === 0
          ? 'none'
          : `0px 3px 100px ${shadow}px rgba(0, 0, 0, 0.13)`,
      borderRadius: `${radius}px`,
      flex: fillSpace === 'yes' ? 1 : 'unset',
    }}
  ><Form.Item 
    style={{ width: "100%" }}
    label={noLabel?null:label}
    labelCol={{span: labelSpan, offset: labelOffset}}
    wrapperCol={{span: wrapperSpan, offset: wrapperOffset}}
    name={name}
    initialValue={formdata[name]}
    rules={rules}
  >
     <DeptTreeSelect />
    </Form.Item></Resizer>);
};


FormDeptTreeSelect.craft = {
  displayName: 'FormDeptTreeSelect',
  props: {
    name: "Dept",
    label: "部门",
    labelSpan: 6,
    labelOffset: 0,
    wrapperSpan: 18,
    wrapperOffset: 0,
    showLabel: "true",
    rules: [{ required: true, message: "归属部门必须选择！" }],
    ...defaultProps
  },
  related: {
    toolbar: FormDeptTreeSelectSettings,
  },
};

//FormDeptTreeSelect.name = "FormDeptTreeSelect";

FormDeptTreeSelect.Icon = () => {
  return (<span>FormDeptTreeSelect</span>);
}